module.exports = __webpack_public_path__ + "img/icon_upload.1280aad2.svg";